import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel } from 'swiper/modules';
import Lottie from 'lottie-react';
import 'swiper/css';
import 'swiper/css/free-mode';
import './Informe2025.css';

const Informe2025 = () => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [showVideoPopup, setShowVideoPopup] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [hasStarted, setHasStarted] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState(new Set());
  const audioRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = 0.5;
    }
  }, []);

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleSlideChange = useCallback((swiper) => {
    setActiveSlideIndex(swiper.activeIndex);
    if (audioRef.current && !hasStarted && !isMuted) {
      audioRef.current.play().then(() => {
        setHasStarted(true);
      }).catch(console.error);
    }
  }, [hasStarted, isMuted]);

  // Desktop lottie configurations
  const desktopLottieConfigs = [
    [], // Slide 0 - no lotties
    [ // Slide 1
      {
        fileName: 'https://cdn.lottielab.com/l/6NaX2qaJmKYVGr.json',
        position: { top: '32.5%', left: '54%' },
        size: { width: '70%', maxWidth: '70%' }
      },
      {
        fileName: 'https://cdn.lottielab.com/l/9m8X7btwh9HMKn.json',
        position: { top: '34%', left: '6%' },
        size: { width: '8%', maxWidth: '8%' },
        video: "https://www.youtube.com/watch?v=oVxI2zgV8Zk"
      },

    ],
    [ // Slide 2
      {
        fileName: 'https://cdn.lottielab.com/l/21bvyXoinhGyaH.json',
        position: { top: '33.5%', left: '52.2%' },
        size: { width: '79.3%', maxWidth: '79.3%' }
      }
    ],
    [ // Slide 3
      {
        fileName: 'https://cdn.lottielab.com/l/6nZjpqMRvZPuTa.json',
        position: { top: '49%', left: '54.8%' },
        size: { width: '87%', maxWidth: '87%' }
      },
      {
        fileName: 'https://cdn.lottielab.com/l/2kzC5Zdc8qBpds.json',
        position: { top: '33.5%', left: '55.49%' },
        size: { width: '10%', maxWidth: '10%' },
        video: "https://www.youtube.com/watch?v=S-8H8-avlUQ"
      },
    ],
    [ // Slide 4

    ],
    [ // Slide 5
      {
        fileName: 'https://cdn.lottielab.com/l/83fWmaPfDP6cHD.json',
        position: { top: '46%', left: '11%' },
        size: { width: '3%', maxWidth: '3%' }
      },
      {
        fileName: 'https://cdn.lottielab.com/l/BaZ24z4xFmwoPF.json',
        position: { top: '39%', left: '66%' },
        size: { width: '48%', maxWidth: '48%' }
      },
      {
        fileName: 'https://cdn.lottielab.com/l/5LDQZgdu18NRGy.json',
        position: { top: '39%', left: '22%' },
        size: { width: '13%', maxWidth: '13%' },
        video: "https://www.youtube.com/watch?v=qphxN0KaF6Y"
      },
      {
        fileName: 'https://cdn.lottielab.com/l/DxxYERrQYG1q5t.json',
        position: { top: '39.6%', left: '32%' },
        size: { width: '10.3%', maxWidth: '11.9%' },
        video: "https://www.youtube.com/watch?v=eposrLxKb3k"
      }

    ],
    [], // Slide 6 - no lotties
  ];

  // Mobile lottie configurations - you can customize these for mobile
  const mobileLottieConfigs = [
    [], // Slide 0 - no lotties
    [ // Slide 1
      {
        fileName: 'https://cdn.lottielab.com/l/FN9tZKbsmoTuEa.json',
        position: { top: '36%', left: '45%' },
        size: { width: '88%', maxWidth: '88%' }
      },
      {
        fileName: 'https://cdn.lottielab.com/l/9m8X7btwh9HMKn.json',
        position: { top: '37%', left: '4%' },
        size: { width: '5%', maxWidth: '5%' },
        video: "https://www.youtube.com/watch?v=oVxI2zgV8Zk"
      },

    ],
    [ // Slide 2
      {
        fileName: 'https://cdn.lottielab.com/l/4KNJ4fboX9aRFb.json',
        position: { top: '48%', left: '47.2%' },
        size: { width: '82%', maxWidth: '82%' }
      },
      {
        fileName: 'https://cdn.lottielab.com/l/2kzC5Zdc8qBpds.json',
        position: { top: '33.5%', left: '66.7%' },
        size: { width: '5.5%', maxWidth: '5.5%' },
        video: "https://www.youtube.com/watch?v=S-8H8-avlUQ"
      }

      // Add your mobile lottie configurations here
    ],
    [ // Slide 3
      {
        fileName: 'https://cdn.lottielab.com/l/5BCboghKsB6EVT.json',
        position: { top: '38%', left: '79.5%' },
        size: { width: '39%', maxWidth: '39%' }
      },
      {
        fileName: 'https://cdn.lottielab.com/l/5LDQZgdu18NRGy.json',
        position: { top: '18%', left: '74%' },
        size: { width: '6%', maxWidth: '6%' },
        video: "https://www.youtube.com/watch?v=qphxN0KaF6Y"
      },
      {
        fileName: 'https://cdn.lottielab.com/l/DxxYERrQYG1q5t.json',
        position: { top: '48%', left: '73.9%' },
        size: { width: '4.8%', maxWidth: '4.8%' },
        video: "https://www.youtube.com/watch?v=eposrLxKb3k"
      }

      // Add your mobile lottie configurations here
    ],
    [ // Slide 4
      // Add your mobile lottie configurations here
    ],
  ];

  // Get current lottie configs based on device type
  const lottieConfigs = isMobile ? mobileLottieConfigs : desktopLottieConfigs;

  const handleLottieClick = (config) => {
    if (config.video) {
      if (audioRef.current) {
        audioRef.current.pause();
      }
      setVideoUrl(config.video);
      setShowVideoPopup(true);
    }
  };

  const closeVideoPopup = () => {
    setShowVideoPopup(false);
    setVideoUrl(null);
    if (audioRef.current && !isMuted) {
      audioRef.current.play();
    }
  };

  const toggleMute = () => {
    if (audioRef.current) {
      if (isMuted) {
        audioRef.current.play();
      } else {
        audioRef.current.pause();
      }
      setIsMuted(!isMuted);
    }
  };

  const getYouTubeEmbedUrl = (url) => {
    const videoId = url.split('v=')[1]?.split('&')[0];
    return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  };

  const renderLottie = (config) => {
    if (!config) return null;

    // Check if it's a URL or local file
    const isUrl = config.fileName.startsWith('http://') || config.fileName.startsWith('https://');

    const containerStyle = {
      position: 'absolute',
      top: config.position.top,
      left: config.position.left,
      transform: 'translate(-50%, -50%)',
      maxWidth: config.size.maxWidth,
      zIndex: 10,
      cursor: config.video ? 'pointer' : 'default'
    };

    // Set either width OR height to maintain aspect ratio
    if (config.size.width) {
      containerStyle.width = config.size.width;
      containerStyle.height = 'auto';
    } else if (config.size.height) {
      containerStyle.height = config.size.height;
      containerStyle.width = 'auto';
    }

    if (isUrl) {
      // For URLs, use the path prop (not src)
      return (
        <div style={containerStyle} onClick={() => handleLottieClick(config)}>
          <Lottie
            path={config.fileName}
            loop={true}
            autoplay={true}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      );
    } else {
      // For local files, use animationData
      const filePath = isMobile ? `mobile/${config.fileName}` : config.fileName;
      const animationData = require(`../../assets/imgs/informe2025/${filePath}`);
      return (
        <div style={containerStyle} onClick={() => handleLottieClick(config)}>
          <Lottie
            animationData={animationData}
            loop={true}
            autoplay={true}
            style={{ width: '100%', height: '100%' }}
          />
        </div>
      );
    }
  };

  // Desktop background images
  const desktopBackgroundImages = [
    'background0.webp',
    'background1.webp',
    'background2.webp',
    'background3.webp',
    'background4.webp',
    'background5.webp',
    'background6.webp'
  ];

  // Mobile background images
  const mobileBackgroundImages = [
    'mobile/part0.webp',
    'mobile/part1.webp',
    'mobile/part2.webp',
    'mobile/part3.webp',
    'mobile/part4.webp',
  ];

  // Get current background images based on device type
  const backgroundImages = isMobile ? mobileBackgroundImages : desktopBackgroundImages;

  // Image preloading functionality
  const preloadImages = useCallback(() => {
    const preloadRange = 2; // Preload 2 images ahead and behind
    const startIndex = Math.max(0, activeSlideIndex - preloadRange);
    const endIndex = Math.min(backgroundImages.length - 1, activeSlideIndex + preloadRange);

    for (let i = startIndex; i <= endIndex; i++) {
      const imageSrc = `${process.env.PUBLIC_URL}/assets/imgs/informe2025/${backgroundImages[i]}`;
      if (!loadedImages.has(imageSrc)) {
        const img = new Image();
        img.onload = () => {
          setLoadedImages(prev => new Set(prev).add(imageSrc));
        };
        img.src = imageSrc;
      }
    }
  }, [activeSlideIndex, backgroundImages, loadedImages]);

  // Preload images when slide changes
  useEffect(() => {
    preloadImages();
  }, [preloadImages]);

  // Determine if GIF should be shown (slides 1 to second-to-last)
  const shouldShowGif = activeSlideIndex >= 1 && activeSlideIndex < (backgroundImages.length);

  return (
    <div className="informe2025-container">
      <audio
        ref={audioRef}
        src={`${process.env.PUBLIC_URL}/assets/imgs/informe2025/informe2025-music.mp3`}
        autoPlay
        loop
        preload="auto"
      />

      <button
        onClick={toggleMute}
        style={{
          position: 'fixed',
          top: '15px',
          right: '15px',
          width: isMobile ? '35px' : '45px',
          height: isMobile ? '35px' : '45px',
          borderRadius: '8px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          border: '1px solid rgba(0, 0, 0, 0.1)',
          color: '#666',
          fontSize: isMobile ? '14px' : '16px',
          cursor: 'pointer',
          zIndex: 1000,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          opacity: '0.8'
        }}
        onMouseEnter={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 1)';
          e.target.style.opacity = '1';
        }}
        onMouseLeave={(e) => {
          e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.9)';
          e.target.style.opacity = '0.8';
        }}
      >
        {isMuted ? '🔇' : '🔊'}
      </button>
      <Swiper
        ref={swiperRef}
        modules={[FreeMode, Mousewheel]}
        direction="horizontal"
        freeMode={{
          enabled: true,
          sticky: false,
          momentumRatio: 0.25,
          momentumVelocityRatio: 0.25
        }}
        mousewheel={{
          enabled: true,
          sensitivity: 2,
          releaseOnEdges: true
        }}
        touchRatio={1}
        touchAngle={90}
        threshold={5}
        followFinger={true}
        simulateTouch={true}
        allowTouchMove={true}
        touchStartPreventDefault={false}
        touchReleaseOnEdges={true}
        cssMode={false}
        preloadImages={false}
        lazy={{
          loadPrevNext: true,
          loadPrevNextAmount: 2,
          loadOnTransitionStart: true
        }}
        updateOnImagesReady={true}
        slidesPerView="auto"
        spaceBetween={0}
        speed={600}
        className="informe-swiper"
        onSlideChange={handleSlideChange}
      >
        {backgroundImages.map((bgImage, index) => (
          <SwiperSlide
            key={`${isMobile ? 'mobile' : 'desktop'}-${index}`}
            className="slide-animated"
            style={{ 
              position: 'relative',
              zIndex: (index === 0 || index === backgroundImages.length - 1) ? 25 : 10
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/assets/imgs/informe2025/${bgImage}`}
              alt={`Background ${index}`}
              className="background-image"
            />
            {lottieConfigs[index] && lottieConfigs[index].map((lottieConfig, lottieIndex) => (
              <div key={lottieIndex}>
                {renderLottie(lottieConfig)}
              </div>
            ))}
          </SwiperSlide>
        ))}

        {/* GIF overlay inside Swiper container */}
        <div
          style={{
            position: 'absolute',
            bottom: isMobile ? '5%': '1%',
            left: '15%',
            zIndex: 20,
            pointerEvents: 'none',
            transition: 'opacity 0.3s ease-in-out',
            opacity: shouldShowGif ? 1 : 0
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/imgs/informe2025/little-girl.gif`}
            alt="Little girl"
            style={{
              width: isMobile ? '140px' : '180px',
              height: 'auto',
              display: 'block'
            }}
          />
        </div>
      </Swiper>

      {showVideoPopup && videoUrl && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}
          onClick={closeVideoPopup}
        >
          <div
            style={{
              position: 'relative',
              width: '90%',
              maxWidth: '800px',
              aspectRatio: '16 / 9',
              backgroundColor: '#000'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closeVideoPopup}
              style={{
                position: 'absolute',
                top: '-40px',
                right: '0',
                background: 'none',
                border: 'none',
                color: 'white',
                fontSize: '24px',
                cursor: 'pointer',
                zIndex: 1001
              }}
            >
              ✕
            </button>
            <iframe
              src={getYouTubeEmbedUrl(videoUrl)}
              style={{
                width: '100%',
                height: '100%',
                border: 'none'
              }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              title="YouTube video player"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Informe2025;
